module.exports = __webpack_public_path__ + "img/egau_tn.ea72ae19.jpg";